<template>
  <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 154.9 116.2" xml:space="preserve"><path id="路径_166" d="M149.1,116.2H5.8c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h143.3
    c3.2,0,5.8,2.6,5.8,5.8l0,0C154.9,113.6,152.3,116.2,149.1,116.2z" class="st0"></path> <path id="路径_167" d="M149.1,86.8H5.8C2.6,86.8,0,84.2,0,81l0,0c0-3.2,2.6-5.8,5.8-5.8h143.3c3.2,0,5.8,2.6,5.8,5.8
    l0,0C155,84.2,152.4,86.8,149.1,86.8C149.1,86.8,149.1,86.8,149.1,86.8z" class="st0"></path> <path id="路径_168" d="M149.1,57.4H5.8c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h143.3
    c3.2,0,5.8,2.6,5.8,5.8l0,0C154.9,54.8,152.3,57.4,149.1,57.4z" class="st0"></path> <path id="路径_170" d="M41.4,8.1l-6.8-3l-3.7-1.6l-7.2-3.2c-1.1-0.4-2.4-0.4-3.5,0L2.6,8.1c-1.5,0.8-2.5,2.3-2.6,4
    v18.4c0.1,1.7,1.1,3.2,2.6,3.9l17.6,7.5c1.1,0.4,2.3,0.4,3.3,0l17.6-7.5c1.5-0.8,2.5-2.3,2.6-4V12.1C43.7,10.4,42.8,9,41.4,8.1z
        M18,23.6L2.9,16.9c-0.7-0.4-1.2-1.1-1.2-1.9c0-0.8,0.6-1.1,1.4-0.8l15.1,6.7c0.7,0.4,1.2,1.1,1.2,1.9C19.4,23.6,18.7,23.9,18,23.6
    L18,23.6z" class="st0"></path> <line id="runLine" x1="59" y1="22.3" x2="149" y2="22.3" class="st2"></line></svg>
</template>

<script>
  import * as d3 from 'd3';
  export default {
    data(){
      return {

      }
    },
    mounted() {

    }
  }
</script>

<style scoped>
  #runLine {
    stroke-dasharray: 90;
    stroke-dashoffset: 0;
    animation: runLine 1.5s ease-in-out infinite;
  }
  .st2 {
    fill: none;
    stroke: #333;
    stroke-width: 12!important;
    stroke-linecap: round!important;
    stroke-miterlimit: 10;
  }

  @keyframes runLine {
    from {
      stroke-dashoffset: 0;
    }
    50%{
      stroke-dashoffset: 85;
    }
    to{
      stroke-dashoffset: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/svgs/ShelfManage.vue